import { Component, Inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { SearchFilter } from 'src/app/model/search-filters/search-filter';

type AddSearchFilterDialogData = Record<string, unknown>;

@Component({
  selector: 'gymfinder-add-search-filter-dialog',
  templateUrl: './add-search-filter-dialog.component.html',
  styleUrls: ['./add-search-filter-dialog.component.scss'],
  standalone: false,
})
export class AddSearchFilterDialogComponent {
  searchFilter: SearchFilter = {};

  constructor(
    private dialogRef: MatDialogRef<AddSearchFilterDialogComponent>,
    @Inject(MAT_DIALOG_DATA) private data: AddSearchFilterDialogData
  ) {}

  public createFilter() {
    this.dialogRef.close(this.searchFilter);
  }

  public closeDialog() {
    this.dialogRef.close();
  }
}
